import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GeneralServiceDetails } from "@/services/livingIn/generalServices/responseFormatter";

export interface GeneralServicesState {
  activeStep: number;
  unitId: string;
  salesOrderId: string;
  serviceRequestDetails: GeneralServiceDetails | null;
  subject: string;
  type: string | null;
}

const MIN_STEP = 1;

const initialState: GeneralServicesState = {
  activeStep: MIN_STEP,
  unitId: "",
  salesOrderId: "",
  serviceRequestDetails: null,
  subject: "",
  type: null,
};

const generalServicesSlice = createSlice({
  name: "generalServicesSlice",
  initialState,
  reducers: {
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    },
    resetGeneralServicesJourney: () => {
      return initialState;
    },
    startGeneralServicesJourney: (
      state,
      action: PayloadAction<Partial<Omit<GeneralServicesState, "activeStep">>>
    ) => {
      return {
        ...state,
        activeStep: MIN_STEP,
        serviceRequestDetails: null,
        subject: "",
        ...action.payload,
      };
    },
    setGeneralServicesDetails: (
      state,
      action: PayloadAction<GeneralServicesState["serviceRequestDetails"]>
    ) => {
      state.serviceRequestDetails = action.payload;
    },
    setGeneralServicesSubject: (state, action: PayloadAction<string>) => {
      state.subject = action.payload;
    },
  },
});

export const {
  setGeneralServicesDetails,
  resetGeneralServicesJourney,
  startGeneralServicesJourney,
  setActiveStep,
  setGeneralServicesSubject,
} = generalServicesSlice.actions;

export default generalServicesSlice.reducer;
